export const DEAL_RENT_TRAP_MAINPAGE = 'deal_rent_trap_mainpage';

export const NEWBUILDING_PROMOS_IN_SEARCH = 'newbuilding_promos_in_search';

export const AA_TEST_50 = 'aud_desktop_aud2904_split_50_main_aa_expf';
export const AA_TEST_30 = 'aud_desktop_aud2904_split_30_main_aa_expf';
export const WEB_TO_APP_BANNER = 'aud_desktop_aud2918_qr_banner_web_to_app';
export const AUD_DESKTOP_AUD2776_CIAN_ASSISTANT_ENTRY_POINT = 'aud_desktop_aud2776_cian_assistant_entry_point';

export const EXPERIMENTS = [
  DEAL_RENT_TRAP_MAINPAGE,
  NEWBUILDING_PROMOS_IN_SEARCH,
  AA_TEST_50,
  AA_TEST_30,
  WEB_TO_APP_BANNER,
  AUD_DESKTOP_AUD2776_CIAN_ASSISTANT_ENTRY_POINT,
];
